<template>
  <Modal
    class="select-mfa-modal"
    size="md"
    :is-open="value"
    data-testid="select-mfa-modal"
    title="Enviar código"
    @close="closeModal"
  >
    <section class="buttons">
      <ButtonBoxIcon
        v-for="button in buttonOption"
        :key="button.label"
        v-bind="button"
        class="button-item"
        @on-click="button.action"
      />
    </section>
  </Modal>
</template>
<script setup lang="ts">
import { Modal } from '@warrenbrasil/nebraska-web';
import { EMethods } from '@/modules/authentication/views/SecurityView/components/MultiFactorAuthentication/types';
import { ButtonBoxIcon } from '@/modules/authentication/views/SecurityView/components/MFALogin/components/ButtonBoxIcon';

interface Props {
  value: boolean;
}

interface Emits {
  (event: 'input', value: boolean): void;
  (event: 'on-without-phone-select'): void;
  (event: 'on-method-select', value: EMethods): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const buttonOption = [
  {
    label: 'Receber por SMS',
    secondaryText: 'O código será enviado por mensagem.',
    icon: 'AA0060',
    action: () => {
      emit('on-method-select', EMethods.SMS);
      closeModal();
    }
  },
  {
    label: 'Receber pelo aplicativo',
    secondaryText: 'O código será enviado por notificação.',
    icon: 'EC0020',
    action: () => {
      emit('on-method-select', EMethods.PUSH);
      closeModal();
    }
  },
  {
    label: 'Estou sem celular',
    secondaryText: 'Apenas funções de emergência disponíveis.',
    icon: 'EF0062',
    action: () => emit('on-without-phone-select')
  }
];

function closeModal() {
  emit('input', false);
}
</script>
<style lang="less" scoped>
.select-mfa-modal {
  :deep(.base-modal--wrapper) {
    max-width: 592px;
  }
}
.buttons {
  width: 464px;
  display: flex;
  flex-direction: column;
  gap: @size-spacing-x400;
  margin-bottom: @size-spacing-x700;
}
</style>
